<template>
  <v-container fluid>
    <v-row v-if="!loading">
      <v-col lg="3"></v-col>
      <v-col cols="12" lg="6" class="d-flex justify-center">
        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
          <form>
            <v-card class="pa-3 form-border registration-form" elevation="10" min-width="400px" max-width="800px">
              <v-card-title class="d-flex justify-center"><h1>{{ $t('msg.sign_up')}}</h1></v-card-title>
              <v-card-text>

<!--                <v-alert v-show="show_duplicate_message" dense outlined prominent type="error">-->
<!--                  <span>{{$t('msg.successfully_register')}}</span>-->
<!--                </v-alert>-->

<!--                &lt;!&ndash;Full Name&ndash;&gt;-->
<!--                <ValidationProvider :rules="{required : false, min:5, max:80, regex: /^[a-zA-Z\s-/@']+$/}"-->
<!--                                    name="fullname" v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'full_name')"-->
<!--                                :label="$t('registration.full_name')"-->
<!--                                :placeholder="$t('error.full_name_required')" :success="valid"-->
<!--                                class="pa-1" outlined v-model="registration.fullname"-->
<!--                                v-on:keyup.enter="passes(reset)"></v-text-field>-->
<!--                </ValidationProvider>-->

<!--                &lt;!&ndash;ID Number&ndash;&gt;-->
<!--                <ValidationProvider-->
<!--                  :rules="{required : true ,min:1, max:20, regex: /^[a-zA-Z0-9/-]+$/}"-->
<!--                  name="idNumber" v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'id_num')"-->
<!--                                :label="$t('registration.id_num')"-->
<!--                                :placeholder="$t('error.id_num_required')"-->
<!--                                :success="valid"-->
<!--                                @keyup="uppercase"-->
<!--                                class="pa-1 uppercase required-class placeholder" outlined-->
<!--                                v-model="registration.idNumber"-->
<!--                                v-on:keyup.enter="passes(reset)"></v-text-field>-->
<!--                </ValidationProvider>-->

<!--                &lt;!&ndash;br Number&ndash;&gt;-->
<!--                <ValidationProvider :rules="{required : true, max:20, min: 3, regex: /^[a-zA-Z0-9]+$/}" name="brNo"-->
<!--                                    v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'business_reg')"-->
<!--                                :label="$t('registration.business_reg')"-->
<!--                                :color="color"-->
<!--                                :placeholder="$t('error.business_reg_required')"-->
<!--                                :success="registration.businessRegistrationNumber != null && registration.businessRegistrationNumber !== '' "-->
<!--                                class="pa-1 required-class uppercase placeholder"-->
<!--                                @keyup="uppercase"-->
<!--                                outlined v-model="registration.businessRegistrationNumber"-->
<!--                                v-on:keyup.enter="passes(reset)"></v-text-field>-->
<!--                </ValidationProvider>-->

<!--                &lt;!&ndash;Company Name&ndash;&gt;-->
<!--                <ValidationProvider :rules="{required: true, min: 5, max: 80, regex: /^[a-zA-Z0-9.&()'\s-]+$/}"-->
<!--                                    name="companyName"-->
<!--                                    v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'company_name')"-->
<!--                                :label="$t('registration.company_name')"-->
<!--                                :placeholder="$t('error.company_name_required')"-->
<!--                                :success="registration.companyName != null && registration.companyName !== '' "-->
<!--                                class="pa-1 required-class"-->
<!--                                outlined v-model="registration.companyName"-->
<!--                                v-on:keyup.enter="passes(reset)"></v-text-field>-->
<!--                </ValidationProvider>-->

<!--                &lt;!&ndash;Business Commencement Date&ndash;&gt;-->
<!--                <v-menu ref="menu" v-model="menu"-->
<!--                        :close-on-content-click="false"-->
<!--                        transition="scale-transition"-->
<!--                        offset-y-->
<!--                        min-width="290px">-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <ValidationProvider :rules="{required: true}"-->
<!--                                        name="date"-->
<!--                                        v-slot="{ errors, valid, failedRules }">-->
<!--                      <v-text-field-->
<!--                        :error-messages="$translatedErrorMessages(failedRules,'commencement_date')"-->
<!--                        :label="$t('registration.commencement_date')" append-icon="mdi-calendar"-->
<!--                        outlined :success="registration.businessCommencementDate"-->
<!--                        :placeholder="$t('error.commencement_date_required')"-->
<!--                        clearable readonly v-model="dateFormatted" v-on:click:clear="removeBusinessCommencementDate"-->
<!--                        class="pa-1 registration-field"-->
<!--                        v-on="on">-->
<!--                        <template v-slot:label>-->
<!--                          {{ $t('registration.commencement_date') }}<span class="red&#45;&#45;text">*</span>-->
<!--                        </template>-->
<!--                      </v-text-field>-->

<!--                    </ValidationProvider>-->
<!--                  </template>-->

<!--                  <v-date-picker color="primary" :max="date" v-model="registration.businessCommencementDate"-->
<!--                                 @input="menu = false"-->
<!--                                 scrollable>-->
<!--                  </v-date-picker>-->
<!--                </v-menu>-->

                <!--Products applied-->
<!--                <ValidationProvider-->
<!--                  :rules="{required: true}"-->
<!--                  name="product"-->
<!--                  v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'product_applied' )"-->
<!--                                  :items="dropdown.products" :label="$t('registration.product_applied')"-->
<!--                                  :placeholder="$t('error.product_applied_required')" :success="valid"-->
<!--                                  @change="handleProductChange"-->
<!--                                  class="pa-1 required-class" item-text="text" item-value="value"-->
<!--                                  :no-data-text="$t('error.drop_down_not_available')"-->
<!--                                  outlined v-model="registration.productApplied"-->
<!--                  ></v-autocomplete>-->
<!--                </ValidationProvider>-->

<!--                <ValidationProvider-->
<!--                  :rules="{required: true, numeric: true, minValue:validation.minAmount, maxValue:validation.maxAmount}"-->
<!--                  name="amount"-->
<!--                  v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field-->
<!--                    :error-messages="$translatedErrorMessages(failedRules,'amount_applied', [validation.minAmount, validation.maxAmount])"-->
<!--                    :label="$t('registration.amount_applied')"-->
<!--                    :placeholder="$t('error.amount_applied_required')"-->
<!--                    :success="valid" @keypress="isNumber" @paste.prevent-->
<!--                    append-icon="mdi-cash" class="pa-1 required-class" outlined v-model="registration.loanAmount"-->
<!--                    prefix="$"-->
<!--                    v-on:keyup.enter="passes(reset)"></v-text-field>-->
<!--                </ValidationProvider>-->

<!--                &lt;!&ndash;Tenure applied in months&ndash;&gt;-->
<!--                <ValidationProvider-->
<!--                  :rules="{required: true, numeric: true, minValue:validation.minTenure, maxValue:validation.maxTenure}"-->
<!--                  name="tenure"-->
<!--                  v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-text-field-->
<!--                    :error-messages="$translatedErrorMessages(failedRules,'tenure', [validation.minTenure, validation.maxTenure])"-->
<!--                    :label="$t('registration.tenure')"-->
<!--                    :placeholder="$t('error.tenure_required')"-->
<!--                    :success="valid" @keypress="isNumber"-->
<!--                    append-icon="mdi-calendar" class="pa-1 required-class" outlined-->
<!--                    v-model="registration.financingTenureApplied"-->
<!--                    :suffix="$t('msg.month_label')"-->
<!--                    v-on:keyup.enter="passes(reset)"></v-text-field>-->
<!--                </ValidationProvider>-->

<!--                &lt;!&ndash;Branch&ndash;&gt;-->
<!--                <ValidationProvider name="branch"-->
<!--                                    :rules="{required: true}"-->
<!--                                    v-slot="{ errors, valid, failedRules }">-->
<!--                  <v-select :error-messages="$translatedErrorMessages(failedRules,'branch')"-->
<!--                            :items="dropdown.branches"-->
<!--                            class="required-class pa-1"-->
<!--                            outlined clearable-->
<!--                            :success="valid"-->
<!--                            item-text="text"-->
<!--                            item-value="value"-->
<!--                            :label="$t('registration.branch')"-->
<!--                            :placeholder="$t('error.branch_required')"-->
<!--                            v-model="registration.branch"-->
<!--                  ></v-select>-->
<!--                </ValidationProvider>-->

                <div class="d-flex justify-center mt-0 mb-2"><b>{{ $t('msg.create_registration') }}</b></div>

                <!--first name-->
                <ValidationProvider :rules="{required : true, min:3, max:80, regex: /^[a-zA-Z\s-/@']+$/}"
                  name="firstname" v-slot="{ errors, valid, failedRules }">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'first_name')"
                  :label="$t('registration.first_name')"
                  :placeholder="$t('error.first_name_required')" :success="valid"
                  class="pa-1 required-class" outlined v-model="registration.firstname"
                  v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>


              <!--last name-->
              <ValidationProvider :rules="{required : true, min:3, max:80, regex: /^[a-zA-Z\s-/@']+$/}"
                                  name="lastname" v-slot="{ errors, valid, failedRules }">
                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'last_name')"
                              :label="$t('registration.last_name')"
                              :placeholder="$t('error.last_name_required')" :success="valid"
                              class="pa-1 required-class" outlined v-model="registration.lastname"
                              v-on:keyup.enter="passes(reset)"></v-text-field>
              </ValidationProvider>

              <!--Products applied-->
              <ValidationProvider
                :rules="{required: true}"
                name="product"
                v-slot="{ errors, valid, failedRules }">
                <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'product_applied' )"
                                :items="dropdown.products" :label="$t('registration.product_applied')"
                                :placeholder="$t('error.product_applied_required')" :success="valid"
                                @change="handleProductChange"
                                class="pa-1 required-class" item-text="text" item-value="value"
                                :no-data-text="$t('error.drop_down_not_available')"
                                outlined v-model="registration.productApplied"
                ></v-autocomplete>
              </ValidationProvider>


                <!--username-->
<!--                <ValidationProvider :rules="{required : true, min:6, max:15, regex: /^[a-zA-Z0-9!#@-]+$/}"
                                    name="username" v-slot="{ errors, valid, failedRules }">
                  <v-text-field
                    :error-messages="errors.length > 0 && Object.keys(failedRules) == 0 ? $translatedServerSideMessages(errors, 'username') : $translatedErrorMessages(failedRules,'username')"
                    :label="$t('msg.username')"
                    :placeholder="$t('error.username_required')" :success="valid"
                    class="pa-1 required-class" outlined v-model="registration.username"
                    append-icon="mdi-account"
                    autocomplete="new-password"
                    v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>-->

                <!--Password-->
<!--                <ValidationProvider :rules="{required : true, min:6, max:15, regex: /^[a-zA-Z0-9!#@-]+$/}"
                                    name="password" v-slot="{ errors, valid, failedRules }"
                                    vid="confirm">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'password')"
                                :label="$t('msg.password')"
                                :placeholder="$t('error.password_required')" :success="valid"
                                append-icon="mdi-lock"
                                class="pa-1 required-class" outlined
                                type="password" v-model="registration.password"
                                autocomplete="new-password"
                                v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>-->

                <!--confirm password-->
<!--                <ValidationProvider
                  :rules="{required : true, min:6, max:15, confirmed:'confirm', regex: /^[a-zA-Z0-9!#@-]+$/}"
                  name="confirmPassword"
                  v-slot="{ errors, valid, failedRules }">
                  <v-text-field :error-messages="$translatedErrorMessages(failedRules,'confirm_password')"
                                :label="$t('registration.confirm_password')"
                                :placeholder="$t('error.confirm_password_required')"
                                :success="valid" append-icon="mdi-lock"
                                class="pa-1 required-class" outlined
                                type="password" v-model="registration.confirmPassword"
                                v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>-->

                <!--Registration Token-->
                <ValidationProvider name="registrationToken"
                                    :rules="{required : true, min:6, max:6, regex: /^[a-zA-Z0-9]+$/}"
                                    v-slot="{ errors, valid, failedRules }">
                  <v-text-field
                    :error-messages="serverErrors.registrationToken ||
                     (errors.length > 0 && Object.keys(failedRules).length === 0
                       ? $translatedServerSideMessages(errors, 'registrationToken')
                       : $translatedErrorMessages(failedRules,'registrationToken'))"
                    :label="$t('registration.verification_code')"
                    :placeholder="$t('error.registrationtoken_required')" :success="valid"
                    append-icon="mdi-check"
                    class="pa-1 required-class" outlined v-model="registration.registrationToken"
                    v-on:keyup.enter="passes(reset)"></v-text-field>
                </ValidationProvider>

                <!--DPA-->
                <ValidationProvider name="consent" :rules="{required:true}"
                                    v-slot="{ errors, valid, failedRules }">
                  <v-checkbox :error-messages="$translatedErrorMessages(failedRules,'consent')"
                              :error="dpaErr && !registration.dpaStatus"
                              v-model="registration.dpaStatus">
                    <template v-slot:label>
                      <div @click.stop="">
                        {{ $t('registration.consent1')}}
                        <a
                          href="#"
                          @click.prevent="tncModal = true"
                        > {{ $t('registration.consent2')}}</a>
                        {{ $t('registration.consent3')}}
                      </div>
                    </template>
                  </v-checkbox>
                </ValidationProvider>
                <div v-show="dpaErr && !registration.dpaStatus" class="dpa-error">{{
                    $t('error.consent_required')
                  }}
                </div>
          </v-card-text>
              <v-divider></v-divider>
          <v-card-actions>
            <v-container fluid>
              <v-row v-show="errors && errors.length>0">
                <v-col class="text-center red--text"><p v-for="error in errors" :key="error">{{$t(error)}}</p></v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-btn class="primary mr-5" @click="passes(register)">{{ $t('registration.register')}}</v-btn>
                  <v-btn class="secondary" @click="cancelRegistration">{{ $t('registration.cancel')}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
          </form>
        </ValidationObserver>
      </v-col>
      <v-col lg="3"></v-col>
    </v-row>
    <v-row v-else>
      <v-col class="text-center spinner-margin" cols="12">
        <v-progress-circular indeterminate color="red"></v-progress-circular>
        <p class="mt-5">{{ $t('msg.loading_text')}}</p>
      </v-col>
    </v-row>
    <v-dialog
      v-model="tncModal"
      persistent
      max-width="550"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('msg.dpa_heading')}}
        </v-card-title>
        <v-divider></v-divider>
        <v-container>
          <v-row>
            <v-col>
              <p>{{ $t('msg.dpa_body1')}}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p>{{ $t('msg.dpa_body2')}}</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p>{{ $t('msg.dpa_body3')}}</p>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            dark
            @click="tncModal = false"
          >
            {{ $t('msg.close')}}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { userService } from '../_services'
import { EventBus } from '../_helpers'

export default {
  name: 'Registration',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      dpaErr: false,
      tncModal: false,
      registration: {},
      loading: true,
      validation: {},
      errors: [],
      error: false,
      serverErrors: {
        registrationToken: '',
      },
      show_duplicate_message: false,
      registrationConfig: {},
      serverError: false,
      menu: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: null,
      currency: '$',
      dropdown: {
        allProducts: [],
        allIdNumberTypes: [],
        products: [],
        idNumberTypes: [],
        branches: []
      }
    }
  },
  methods: {
    cancelRegistration () {
      this.$router.push('/')
    },
    register() {
      if (this.registration.dpaStatus) {
        this.errors = [];
        userService.register(this.registration).then(r => {
          if (r.data.successful) {
            if (r.data.message && r.data.message === 'cloned_user') {
              this.$router.push({ path: `/`, query: { clonedUser: true } });
            } else {
              this.$router.push({ path: `/`, query: { success: true } });
            }
          } else {
            const duplicateError = r.data.errorList.find(e => e.rule === 'duplicate');
            if (duplicateError && duplicateError.field === 'username') {
              // Set the duplicate error message directly on the registrationToken field
              this.serverErrors.registrationToken = this.$t('error.verification_code_duplicate');
            } else if (r.data.errorList.length > 0) {
              this.initErrorList(r.data.errorList);
            }
          }
        }).catch(() => {
          this.errors = [];
          this.errors.push(this.$t('error.registration_error'));
        });
      } else {
        this.dpaErr = true;
      }
    },
    handleProductChange () {
      this.validation = this.dropdown.products.filter(p => p.value === this.registration.productApplied)[0].validation
    },
    handleIdTypeChange () {
    },
    initErrorList (errors) {
      if (errors.filter(e => e.field === 'general').length > 0) {
        this.errors = []
        this.errors.push('error.repeating_user')
      } else {
        let e = {}
        errors.forEach(error => {
          if (error.rule !== undefined) {
            e[error.field] = [{ rule: error.rule }]
          }
        })
        this.$refs.observer.setErrors(e)
      }
    },
    initDropDownData () {
      userService.getDropdownData()
        .then((response) => {
          this.response = response.data.dataResponse
          this.populateDropDowns()
          this.validation.minAmount = 500
          this.validation.maxAmount = 999999999
          this.validation.minTenure = 1
          this.validation.maxTenure = 240
          this.loading = false
        }).catch(error => {
          console.log(error)
          this.loading = false
          this.$router.push({ path: `/`, query: { registrationInitError: true } })
        })
    },
    populateDropDowns () {
      let lang = this.$cookies.get('nedas_lang').toUpperCase()
      this.dropdown.allProducts = this.response.productList
      this.dropdown.products = this.response.productList[lang]
      /*this.dropdown.branches = this.response.branchList[lang]*/
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`
    },
    removeBusinessCommencementDate () {
      this.registration.businessCommencementDate = null
    },
    uppercase () {
      this.registration.idNumber = this.registration.idNumber.toUpperCase()
      this.registration.businessRegistrationNumber = this.registration.businessRegistrationNumber.toUpperCase()
    }
  },
  created () {
    EventBus.$on('handleLanguageChange', this.populateDropDowns)
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.registration.businessCommencementDate)
    }
  },
  watch: {
    'registration.businessCommencementDate' (val) {
      this.dateFormatted = this.formatDate(this.registration.businessCommencementDate)
    }
  },
  mounted () {
    let host = window.location.host
    userService.init(host).then(r => {
      this.registrationConfig = r.data
      if (r.data.primary !== null) {
        this.$vuetify.theme.themes.light.primary = this.registrationConfig.primary
      }
    }).catch(() => {
      this.error = true
    })
    this.initDropDownData()
  }
}
</script>

<style scoped>
  .logoStyle {
    max-width: 250px;
  }

  .form-border {
    border-top: 3px solid #64c2ef
  }

  .registration-form {
    padding-bottom: 20px;
    margin-bottom: 70px;
    font-size: 16px;
  }

  .spinner-margin {
    margin-top: 150px;
  }
</style>
<style>
  .registration-form .theme--light.v-label {
    color: rgba(0,0,0,.90);
  }

  .required-class label::after {
    content: "*";
    color: red;
  }

.dpa-error {
  font-size: 12px;
  font-family: 'Ubuntu', sans-serif;
  color: #FF5252;
  line-height: 1;
  margin-top: -15px;
}

.msg-error {
  font-size: 12px;
  font-family: 'Ubuntu', sans-serif;
  color: #FF5252;
  line-height: 1;
  margin-top: -35px !important;
  padding-left: 23px;
}

.uppercase input {
  text-transform: uppercase;
}

  .placeholder input::placeholder {
    text-transform: none !important;
  }

  .title-tenure {
    margin-bottom: -10px;
    margin-top: -15px;
    color: black;
  }

  @media only screen and (max-width: 576px) {
    /* For desktop: */
    .registration-field label {
      font-size: 13px !important;
    }

    .registration-field input::placeholder {
      font-size: 12px !important;
    }

    .registration-field input::placeholder {
      font-size: 12px !important;
    }

    .tenure-responsive {
      width: 50%;
    }
  }

  @media only screen and (min-width: 576px) {
    .registration-field input::placeholder {
      font-size: 14px !important;
    }
  }
</style>
